const env = process.env.NODE_ENV;
export const japanhaulSite =
  env === "production"
    ? "https://japanhaul.com"
    : "https://staging.japanhaul.com";

export const signupUrl = `${japanhaulSite}/account/register`
export const loginUrl = `${japanhaulSite}/account/login`
